import Tab from './ui';

export { TabProvider, type TabProviderProps, useTabContext } from './common/utils/tab-context';

export default Tab;
